import overArg from './_overArg.js';

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

export default getPrototype;



//////////////////
// WEBPACK FOOTER
// /smarthelpnodeweb-ci-5863/workspace/Release_Build/~/lodash-es/_getPrototype.js
// module id = 386
// module chunks = 0 1 2